// extracted by mini-css-extract-plugin
export default {"paragraph":"Paragraph--paragraph--Ts1f+"};